<template>
    <i class="fas fa-chart-area text-dark"></i>
</template>
<script></script>